
<div class="p-3" >
  <div class="row">
    <div class="ml-auto mt-3 mt-md-0 d-flex align-items-center p-1">
      <button class="btn btn-info" style="width: 100%;" (click)="edit()" type="button">Aggiungi</button>
      <button class="btn btn-warning " style="width: 100%;" (click)="MostraEliminati()" type="button">{{eliminati? 'Nascondi Eliminati':'Mostra Eliminati' }}</button>
    </div>

  </div>
</div>

<div class="table-responsive">
  <table class="table bg-white table-hover align-middle mb-0">
    <thead>
      <tr>
        <th>Corriere</th>
        <th>Test</th>
        <th scope="col">Azioni</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let item of Lista | slice: (page-1) * pageSize : (page-1) * pageSize + pageSize" >
        <td class="align-middle">
          {{ item.nominativo }}
        </td>
<!--        <span  >-->
<!--&lt;!&ndash;          <span class="badge badge-light text-dark rounded-pill font-16 mr-1">&ndash;&gt;-->
<!--&lt;!&ndash;            <i-feather name="user" class="feather-sm"></i-feather>&ndash;&gt;-->
<!--&lt;!&ndash;          </span>&ndash;&gt;-->
<!--          -->
<!--        </span>-->
<!--        <span *ngIf="item.modifica">-->
<!--          <input [(ngModel)]="item.nominativo" placeholder="nominativo" type="text" name="nominativo" class="form-control">-->
<!--        </span>-->

<!--      <td class="align-middle" >-->
<!--        <span *ngIf="!item.modifica" >-->
<!--          {{ item.link }}-->
<!--        </span>-->
<!--        <span *ngIf="item.modifica">-->
<!--          <input [(ngModel)]="item.link" placeholder="Link" type="text" name="codice_univoco" class="form-control">-->
<!--        </span>-->
<!--      </td>-->
<!--        <td class="align-middle" >-->
<!--        <span *ngIf="!item.modifica" >-->
<!--          {{ item.tipiObject && item.tipiObject.length>0? item.tipiObject[0]?.label : '' }}-->
<!--        </span>-->
<!--          <span *ngIf="item.modifica">-->
<!--          <ng-multiselect-dropdown [settings]="dropdownSettings" *ngIf="Tipi"  [placeholder]="'Seleziona'" name="categorie" [data]="Tipi" [(ngModel)]="item.tipiObject">-->
<!--            </ng-multiselect-dropdown>-->
<!--        </span>-->
<!--        </td>-->
<!--        <td class="align-middle" >-->
<!--        <span *ngIf="!item.modifica" >-->
<!--          {{ item.key }}-->
<!--        </span>-->
<!--          <span *ngIf="item.modifica">-->
<!--          <input [(ngModel)]="item.key" placeholder="key" type="text" name="codice_univoco" class="form-control">-->
<!--        </span>-->
<!--        </td>-->
        <td class="align-middle" > {{ item.test ? 'Si':'No' }}</td>
<!--          <span *ngIf="item.modifica">-->
<!--          <input [(ngModel)]="item.test" placeholder="test" type="checkbox" name="codice_univoco" class="form-control">-->
<!--        </span>-->

<!--        <td class="align-middle" >-->
<!--        <span *ngIf="!item.modifica" >-->
<!--          {{ item.username }}-->
<!--        </span>-->
<!--          <span *ngIf="item.modifica">-->
<!--          <input [(ngModel)]="item.username" placeholder="username" type="text" name="codice_univoco" class="form-control">-->
<!--        </span>-->
<!--        </td>-->
<!--        <td class="align-middle" >-->
<!--        <span *ngIf="!item.modifica" >-->
<!--        </span>-->
<!--          <span *ngIf="item.modifica">-->
<!--          <input [(ngModel)]="item.password" placeholder="password" type="password" name="codice_univoco" class="form-control">-->
<!--        </span>-->
<!--        </td>-->
        <td class="align-middle">
          <a href="javascript:void(0)" ngbTooltip="Modifica" class="link font-16 text-info font-medium mr-2" (click)='edit(item)'>
            <i-feather name="edit-3" class="feather-sm"></i-feather>
          </a>
<!--          <a *ngIf="item.modifica" href="javascript:void(0)" ngbTooltip="Salva" class="link font-16 text-success font-medium mr-2" (click)='edit(item)'>-->
<!--            <i-feather name="save" class="feather-sm"></i-feather>-->
<!--          </a>-->
          <a *ngIf="item.enabled"  href="javascript:void(0)" class="link text-danger font-16 font-weight-bold" (click)='delete(item)'>
            <i-feather name="trash-2" class="feather-sm"></i-feather>
          </a>
          <a *ngIf="!item.enabled" href="javascript:void(0)" class="link text-orange font-16 font-weight-bold" (click)='renew(item)'>
            <i-feather name="plus" class="feather-sm"></i-feather>
          </a>
          <!-- <a href="javascript:void(0)" class="link font-16 font-weight-bold" (click)='delete(co)'>
            <i-feather name="trash-2" class="feather-sm"></i-feather>
          </a> -->
        </td>
      </tr>
    </tbody>
  </table>
  </div>


  <div class="d-flex justify-content-center p-2 pt-3 bg-white border-top">
    <ngb-pagination (pageChange)="getPage($event)" id="paginationComponent" [maxSize]="10"
      [collectionSize]="collectionSize" [pageSize]="pageSize">
    </ngb-pagination>
  </div>


<!--  <aside class="customizer"  >-->
<!--    <div style="position: absolute; bottom: 20px; left: -100px; ">-->
<!--      <div class="d-md-flex align-items-center justify-content-end">-->
<!--        <button type="submit" (click)="SalvaTutto()" class="ml-auto btn btn-rounded btn-success p-2 waves-effect waves-light">-->
<!--          <span class="ml-1 text-white font-weight-bold"> Salva </span>-->
<!--          <i-feather name="save" class="feather-sm "></i-feather>-->
<!--        </button>-->
<!--      </div>-->
<!--    </div>-->
<!--  </aside>-->
